export default __webpack_public_path__ + "static/media/digital-7.93911ab1.ttf";